import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.splice";
import "core-js/modules/web.dom-collections.for-each";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import ClientInfo from './ClientInfo.vue';
import ProxyInfo from './ProxyInfo.vue';

var MemberInfoForm = /*#__PURE__*/function (_Vue) {
  _inherits(MemberInfoForm, _Vue);

  var _super = _createSuper(MemberInfoForm);

  function MemberInfoForm() {
    var _this;

    _classCallCheck(this, MemberInfoForm);

    _this = _super.apply(this, arguments);
    _this.clientList = [];
    _this.proxyList = [];
    return _this;
  }

  _createClass(MemberInfoForm, [{
    key: "handleClientDelete",
    value: function handleClientDelete(item) {
      var _this2 = this;

      var index = item.$index,
          data = item.row; // 遍历 proxyList dldx，储存引用的坐标

      var refTuples = [];
      this.proxyList.forEach(function (p, i) {
        p.dldx.forEach(function (d, j) {
          if (d === data) {
            refTuples.push([i, j]);
          }
        });
      });

      if (refTuples.length === 0) {
        // 如果没有引用
        this.clientList.splice(index, 1);
      } else {
        // 如果有引用
        this.$confirm('已有代理人代理此当事人, 是否删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'question',
          onConfirm: function onConfirm() {
            _this2.clientList.splice(index, 1); // 按坐标删除 proxyList 中的引用


            refTuples.forEach(function (t) {
              _this2.proxyList[t[0]].dldx.splice(t[1], 1);
            });
          },
          onCancel: function onCancel() {}
        });
      }
    } // 与 BaseInfoForm 统一

  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (valid) {
        return valid;
      };
      var valid = this.clientList.length !== 0;

      if (!valid) {
        this.$message.error('当事人为空，请创建当事人');
      }

      callback(valid);
    }
  }]);

  return MemberInfoForm;
}(Vue);

__decorate([Prop({
  required: true,
  type: Array
})], MemberInfoForm.prototype, "litigationStatusIdOptions", void 0);

MemberInfoForm = __decorate([Component({
  components: {
    ClientInfo: ClientInfo,
    ProxyInfo: ProxyInfo
  }
})], MemberInfoForm);
export default MemberInfoForm;